/**
 * These should be the units from AvailableUnits in
 * packages/blocks-configurators/src/configurators/NumberInputConfigurator/utils.ts
 */
export const standardUnits = [
  'l',
  'm',
  'm2',
  'cubic-meter',
  'cubic-meter-h',
  'l',
  'ls',
  'a',
  'kva',
  'w',
  'kw',
  'kwh',
  'wp',
  'kwp',
  'percent',
  'v',
  'euro',
  'c'
]
